import apiClient from './apiClient';

export const getAccountBalance = (params = {}) => {
  return apiClient.get("/account-balance", {
    params: params,
  });
};

export const getAccountBalanceWebsites = () => {
  return apiClient.get("/account-balance/websites");
};

export const getAccountBalanceAccounts = () => {
  return apiClient.get("/account-balance/accounts");
};
